import { invokeApi } from "../../bl_libs/invokeApi";

export const getTrackerTagsApi = async ({
  page = 1,
  limit = 200,
  search = "",
  status = "active",
} = {}) => {
  const queryParams = [];
  if (page) queryParams.push(`page=${encodeURIComponent(page)}`);
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
  if (status) queryParams.push(`status=${encodeURIComponent(status)}`);

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

  const requestObj = {
    path: `/api/tracker_tag${queryString}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const addTrackerTagApi = async (data) => {
  const requestObj = {
    path: `/api/tracker_tag`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const updateTrackerTagApi = async (id, data) => {
  const requestObj = {
    path: `/api/tracker_tag/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const deleteTrackerTagApi = async (id) => {
  const requestObj = {
    path: `/api/tracker_tag/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
